import React from "react";
import usePromosHook from "./hooks/usePromosHook";
import { CustomTable } from "../series/StyledComponent";
import useScreenSizeHook from "../utils/useScreenSizeHook";
import { Button, Col, Row, Select } from "antd";
import { ComponentTitle, PageTitleLastCol, SearchForm } from "../custom-components";
import AddEditPromoModal from "./modals/AddEditPromoModal";
import { PROMO_TYPE_OPTIONS } from "./promo-types";
import PromoExportModal from "./modals/PromoExportModal";

const PromosComponent = () => {
	const { height } = useScreenSizeHook();
	const {
		form,
		promoColumns,
		pagination,
		isLoading,
		editHandler,
		createUpdateCuePoint,
		openCreatePromoForm,
		typeFilter,
		filterByType,
		handleTableChange,
		searchData,
		promoData,
		promoEditId,
		onCancelPromoForm,
		isPromoFormOpen,
		handleExport,
		isExportModalOpen,
		openPromoExportModal,
		closePromoExportModal,
		includeDistribution,
		setIncludeDistribution,
	} = usePromosHook();
	return (
		<>
			<Row justify="space-between" align="middle">
				<Col>
					<ComponentTitle>Promos</ComponentTitle>
				</Col>
				<PageTitleLastCol>
					<Button onClick={openPromoExportModal} type="primary" style={{ marginLeft: 8 }}>
						Export
					</Button>
					<SearchForm
						form={form}
						searchData={searchData}
						placeholder="Search by Ref ID, Promo ID, URL or Amagi ID"
					/>
					<Select
						allowClear
						placeholder="All Types"
						value={typeFilter}
						onChange={filterByType}
						options={PROMO_TYPE_OPTIONS}
						style={{ width: 140, marginLeft: 8 }}
					/>
					<Button onClick={openCreatePromoForm} type="primary" style={{ marginLeft: 8 }}>
						+ Create Promo
					</Button>
				</PageTitleLastCol>
			</Row>
			<CustomTable
				onChange={handleTableChange}
				columns={promoColumns}
				dataSource={promoData}
				scroll={{ y: height - 265 }}
				loading={isLoading}
				pagination={{
					...pagination,
					showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} Promos`,
				}}
				rowClassName={(record: any) =>
					String(record.promo_id) === String(promoEditId) ? "selected-promo-row" : ""
				}
				onRow={(record: any) => {
					return {
						onClick: () => {
							editHandler(record);
						},
					};
				}}
			/>
			<PromoExportModal
				isOpen={isExportModalOpen}
				typeFilter={typeFilter}
				includeDistribution={includeDistribution}
				setIncludeDistribution={setIncludeDistribution}
				exportPromos={handleExport}
				closePromoExportModal={closePromoExportModal}
			/>
			{isPromoFormOpen && (
				<AddEditPromoModal
					form={form}
					promoEditId={promoEditId}
					onCancelPromo={onCancelPromoForm}
					onOkPromo={createUpdateCuePoint}
					loading={isLoading}
				/>
			)}
		</>
	);
};

export default PromosComponent;
